export default __webpack_public_path__ + "static/media/bjTtPrt.ca96a5f0.webp";